<template>
  <v-autocomplete
    :value="value"
    class="centered-input"
    placeholder="---"
    :items="items"
    hide-details
    dense
    :disabled="disabled"
    solo
    flat
    :outlined="disabled"
    :background-color="backgroundColor"
    :dark="!disabled"
    return-object
    :item-text="itemText"
    append-icon="mdi-chevron-down"
    :menu-props="{
      closeOnContentClick: true,
      maxHeight: 200,
      offsetY: true,
      transition: false,
    }"
    data-cy="base-item-select"
    :prepend-inner-icon="value.icon"
    v-bind="$attrs"
  >
    <template slot="item" slot-scope="{ item }">
      <v-list-item link @click="update(item)" :data-cy="item.name">
        <slot name="item">
          <v-list-item-title>
            {{ item[itemText] }}
          </v-list-item-title>
        </slot> 
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
//
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      default: function () {
        return this.items[0]
      }
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: function () {
        return this.disabled ? "disabled_color" : "primary";
      },
    },
    itemText: {
      type: String,
      default: "name"
    }
  },
  methods: {
    update(item) {
      if (this.value.id === item.id) {
        return;
      }
      this.$emit("input", item);
    },
  },
};
</script>

<style scoped>
* {
  text-transform: none !important;
}
.centered-input >>> input {
  text-align: center;
  font-size: 0.95em;
}
</style>
